import React from "react";

import useAxiosPrivate from "@/hooks/useAxiosPrivate";
import { useQueryClient } from "@tanstack/react-query";

import { FaRegTrashCan } from "react-icons/fa6";
import { BiSolidEditAlt } from "react-icons/bi";

export default function CustomerGroupSettingsSecondaryActions({ customer_group_id }) {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();

  const deleteCustomerSettings = async () => {
    await axiosPrivate.delete(`/customers_group/settings/${customer_group_id}`);

    queryClient.invalidateQueries({ queryKey: ["CustomerGroupSettings"] });
  };

  return (
    <>
      <button
        className="flex items-center gap-2"
        onClick={() => deleteCustomerSettings()}
      >
        <FaRegTrashCan />
      </button>
      <a
        href={`/customersgroup/settings/${customer_group_id}`}
        className="flex items-center gap-2"
      >
        <BiSolidEditAlt />
      </a>
    </>
  );
}
